// Importing necessary modules and dependencies
import * as THREE from 'three';
import EventDispatcher from '../common/EventDispatcher';
import {
    Global
} from '../common/global';

import { laneInfo } from '../common/lanes';



const START_LINE_POS = new THREE.Vector3(.3,-1.5,-15);
const START_LINE_ROT = new THREE.Vector3(-Math.PI*0.5,0,0);

// const FINISH_LINE_POS = new THREE.Vector3(.3,-1.5,-50);
// const FINISH_LINE_ROT = new THREE.Vector3(-Math.PI*0.5,0,0);

const FINISH_LINE_POS = new THREE.Vector3(0.0453, 0.341-1.5, -7800);
const FINISH_LINE_ROT = new THREE.Vector3(-Math.PI*0.5,0,0);
// Definition of the GameScene class
export default class GameScene {
    // Constructor takes a scene and camera as parameters
    constructor(scene, camera) {
        this.scene = scene;
        this.camera = camera;

        this.onEvents=this.onEvents.bind(this)
    }

    // Initialization method for setting up event listeners and initial state
    init(gui) {
        this.gui=gui;
        

        // Getting the event dispatcher instance
        this.events = EventDispatcher.getObj();

        // Adding event listeners for GAMESCENE_EVENTS and PLAYER_EVENTS
        this.events.addEventListener("GAMESCENE_EVENTS", this.onEvents);
        this.events.addEventListener("PLAYER_EVENTS", this.onEvents);
        this.events.addEventListener("GAME_EVENTS", this.onEvents);

        // Creating a dark material for placeholder objects
        this.darkMaterial = new THREE.MeshBasicMaterial({
            color: 'black'
        });
        Global.collectables=[]
        this.startTime=0
        this.blockerMesh=null;
    }

    // Method to handle changes in the GUI for sky settings
    setSkySettings() {
        // Updating the sky's uniforms based on GUI changes
        const uniforms = this.sky.material.uniforms;
        uniforms['turbidity'].value = this.effectController.turbidity;
        uniforms['rayleigh'].value = this.effectController.rayleigh;
        uniforms['mieCoefficient'].value = this.effectController.mieCoefficient;
        uniforms['mieDirectionalG'].value = this.effectController.mieDirectionalG;

        // Calculating spherical coordinates for the sun based on GUI values
        const phi = THREE.MathUtils.degToRad(90 - this.effectController.elevation);
        const theta = THREE.MathUtils.degToRad(this.effectController.azimuth);

        // Setting sun position based on spherical coordinates
        this.sun.setFromSphericalCoords(1, phi, theta);

        // Updating sun position in the uniforms
        uniforms['sunPosition'].value.copy(this.sun);
    }

    // Method to add a sky to the scene
  // Add Clouds to the Sky
  addCollectables() {
    const collectableGeo = new THREE.PlaneGeometry(1.4 * 0.5733945, 1.4);
    this.collectableMat1 = new THREE.MeshBasicMaterial({
        map: Global.assets['textures']['caramel']['asset'],
        side: THREE.FrontSide,
        transparent: true,
        alphaTest: 0.75,
        roughness: 1
    });
    this.collectableMat1.userData = { 'collectableType': 'caramel' };

    this.collectableMat2 = new THREE.MeshBasicMaterial({
        map: Global.assets['textures']['mocha']['asset'],
        side: THREE.FrontSide,
        transparent: true,
        alphaTest: 0.75,
        roughness: 1
    });
    this.collectableMat2.userData = { 'collectableType': 'mocha' };

    this.collectableMat3 = new THREE.MeshBasicMaterial({
        map: Global.assets['textures']['original275']['asset'],
        side: THREE.FrontSide,
        transparent: true,
        alphaTest: 0.75,
        roughness: 1
    });
    this.collectableMat3.userData = { 'collectableType': 'original275' };

    const _level = Global.gameLevel > 1 ? 2 : 1;
    const scaleFactor = 20;
    const lanes = ["lane1", "lane2", "lane3", "lane4", "lane5"];

    let allPoints = [];

    // Collect points from lane1 to lane5 within the 10%-90% range
    lanes.forEach(lane => {
        const points = laneInfo[`level${_level}`][lane].map(point =>
            new THREE.Vector3(point.x * scaleFactor, point.y * scaleFactor, point.z * scaleFactor)
        ).reverse();

        const startIdx = Math.floor(points.length * 0.1);
        const endIdx = Math.ceil(points.length * 0.9);

        allPoints.push(...points.slice(startIdx, endIdx));
    });

    // Shuffle points randomly
    allPoints = allPoints.sort(() => Math.random() - 0.5);

    const selectedPoints = [];
    const minDistance = 0.00035 * allPoints.length; // 0.5% of curve length

    let collectableTypes = [1, 2, 3];
    collectableTypes = this.shuffleArray(collectableTypes);

    // Track placed collectables and their types for each lane
    const laneCollectables = {
        lane1: [],
        lane2: [],
        lane3: [],
        lane4: [],
        lane5: []
    };

    for (let i = 0; i < allPoints.length && selectedPoints.length < 24; i++) {
        const point = allPoints[i];

        // Determine which lane the point belongs to
        const lane = lanes.find(lane => {
            const lanePoints = laneInfo[`level${_level}`][lane].map(p =>
                new THREE.Vector3(p.x * scaleFactor, p.y * scaleFactor, p.z * scaleFactor)
            );
            return lanePoints.some(lp => lp.equals(point));
        });

        if (!lane) continue; // Skip if the point doesn't belong to any lane

        // Ensure minimum distance between collectables on the same lane
        if (laneCollectables[lane].every(sp => sp.position.distanceTo(point) > minDistance * scaleFactor)) {
            // Determine the next collectable type
            const nextCollectableType = collectableTypes[selectedPoints.length % 3];

            // Check if the same type is already placed nearby on any lane
            const nearbySameType = Object.values(laneCollectables).some(collectables =>
                collectables.some(pc =>
                    pc.position.distanceTo(point) < minDistance * scaleFactor &&
                    pc.userData.collectableType === nextCollectableType
                )
            );

            if (!nearbySameType) {
                selectedPoints.push(point);

                const collectable = new THREE.Mesh(collectableGeo, this[`collectableMat${nextCollectableType}`]);
                collectable.position.copy(point);
                collectable.scale.set(1.5, 1.5, 1.5);
                collectable.position.y += 1;
                collectable.userData = { collectableType: nextCollectableType };

                Global.collectables.push(collectable);
                this.scene.add(collectable);

                // Track the placed collectable for the specific lane
                laneCollectables[lane].push(collectable);
            }
        }
    }
}
//   addCollectables() {
//     const collectableGeo = new THREE.PlaneGeometry(1.4 * 0.5733945, 1.4);
//     this.collectableMat1 = new THREE.MeshBasicMaterial({
//         map: Global.assets['textures']['caramel']['asset'],
//         side: THREE.FrontSide,
//         transparent: true,
//         alphaTest: 0.75,
//         roughness: 1
//     });
//     this.collectableMat1.userData = { 'collectableType': 'caramel' };

//     this.collectableMat2 = new THREE.MeshBasicMaterial({
//         map: Global.assets['textures']['mocha']['asset'],
//         side: THREE.FrontSide,
//         transparent: true,
//         alphaTest: 0.75,
//         roughness: 1
//     });
//     this.collectableMat2.userData = { 'collectableType': 'mocha' };

//     this.collectableMat3 = new THREE.MeshBasicMaterial({
//         map: Global.assets['textures']['original275']['asset'],
//         side: THREE.FrontSide,
//         transparent: true,
//         alphaTest: 0.75,
//         roughness: 1
//     });
//     this.collectableMat3.userData = { 'collectableType': 'original275' };

//     const _level = Global.gameLevel > 1 ? 2 : 1;
//     const scaleFactor = 20;
//     const lanes = ["lane1", "lane2", "lane3", "lane4", "lane5"];

//     let allPoints = [];

//     // Collect points from lane1 to lane5 within the 10%-90% range
//     lanes.forEach(lane => {
//         const points = laneInfo[`level${_level}`][lane].map(point =>
//             new THREE.Vector3(point.x * scaleFactor, point.y * scaleFactor, point.z * scaleFactor)
//         ).reverse();

//         const startIdx = Math.floor(points.length * 0.1);
//         const endIdx = Math.ceil(points.length * 0.9);

//         allPoints.push(...points.slice(startIdx, endIdx));
//     });

//     // Shuffle points randomly
//     allPoints = allPoints.sort(() => Math.random() - 0.5);

//     const selectedPoints = [];
//     const minDistance = 0.00035 * allPoints.length; // 0.5% of curve length

//     let collectableTypes = [1, 2, 3];
//     collectableTypes = this.shuffleArray(collectableTypes);

//     // Track placed collectables and their types
//     const placedCollectables = [];

//     for (let i = 0; i < allPoints.length && selectedPoints.length < 18; i++) {
//         const point = allPoints[i];

//         // Ensure minimum distance
//         if (selectedPoints.every(sp => sp.distanceTo(point) > minDistance * scaleFactor)) {
//             // Check if the same type is already placed nearby
//             const nearbySameType = placedCollectables.some(pc => 
//                 pc.position.distanceTo(point) < minDistance * scaleFactor && 
//                 pc.userData.collectableType === collectableTypes[selectedPoints.length % 3]
//             );

//             if (!nearbySameType) {
//                 selectedPoints.push(point);
//                 const collectableType = collectableTypes[selectedPoints.length % 3];

//                 const collectable = new THREE.Mesh(collectableGeo, this[`collectableMat${collectableType}`]);
//                 collectable.position.copy(point);
//                 collectable.scale.set(1.5, 1.5, 1.5);
//                 collectable.position.y += 1;
//                 collectable.userData = { collectableType: collectableType };

//                 Global.collectables.push(collectable);
//                 this.scene.add(collectable);

//                 // Track the placed collectable
//                 placedCollectables.push(collectable);
//             }
//         }
//     }
// }
  shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]]; // Swap elements
    }
    return array;
}


// Ensure the Clouds Stay in Place but Rotate Slowly
updateClouds(camera) {
    if (this.cloudGroup && camera) {
        // Make clouds rotate only when the camera rotates
        this.cloudGroup.position.z = camera.position.z;
    }
}


// Create Cloud Sprite
createCloud(position) {
    const cloud = new THREE.Sprite(this.cloudMaterials[Math.floor(Math.random() * this.cloudMaterials.length)]);
    cloud.scale.set(50, 30, 1); // Adjust size
    cloud.position.set(position.x, position.y, position.z);
    return cloud;
}


    // Event handler for various events
    onEvents(data) {
      
        switch (data['message']['event_type']) {
          
            case "create_scene":
                this.createScene();
                break;
            case "place_blocker":
                this.moveBlocker(data['message']['data']);
                break;
            case "update":
                this.update(data['message']['data']);
                this.updateClouds(data['message']['data']['camera'])
                break;
            case "show_indicator":
                this.showOrHideIndicator(true, data['message']['data']);
                break;
            case "hide_indicator":
                this.showOrHideIndicator(false, data['message']['data']);
                break;
            case "start_game":
                this.startTimer();
                break;
            case "game_over":
                this.stopTimer();
                break;
            case "dispose":
                this.dispose();
                this.stopTimer();
                break;
            case "time_deduct":
                this.doTimeDeduct(data['message']['data']);
                break;
        }
    }
    stopTimer(){
        clearInterval(this.timerInterval);
    }
    doTimeDeduct(data){

        this.startTime+=1500
    }
    startTimer() {
        this.startTime = Date.now(); // Record the start time
        let elapsed = { minutes: 0, seconds: 0, milliseconds: 0 };
        let pauseStartTime = 0; // Store the time when the game is paused
        let totalPausedTime = 0; // Accumulate total paused time
    
        this.timerInterval = setInterval(() => {
            if (Global.gamePaused) {
                // If the game is paused, record the time when the pause started
                if (pauseStartTime === 0) {
                    pauseStartTime = Date.now();
                }
                return; // Skip the update logic while paused
            } else if (pauseStartTime > 0) {
                // If the game was just unpaused, calculate the total paused time
                totalPausedTime += Date.now() - pauseStartTime;
                pauseStartTime = 0; // Reset pauseStartTime
            }
    
            // Calculate the elapsed time, adjusting for paused time
            let now = Date.now();
            let timeDiff = now - this.startTime - totalPausedTime;
    
            elapsed.minutes = Math.floor(timeDiff / 60000); // Convert to minutes
            elapsed.seconds = Math.floor((timeDiff % 60000) / 1000); // Get remaining seconds
            elapsed.milliseconds = Math.floor((timeDiff % 1000) / 10); // Limit to 2 digits
    
            // Update the global time variable
            Global[`level${Global.gameLevel}Time`] = elapsed.minutes * 60 + elapsed.seconds + (elapsed.milliseconds / 1000);
    
            // Update the timer display
            document.querySelector(".game_header .time").innerHTML =
                `${elapsed.minutes < 10 ? '0' : ''}${elapsed.minutes}:` +
                `${elapsed.seconds < 10 ? '0' : ''}${elapsed.seconds}:` +
                `${elapsed.milliseconds < 10 ? '0' : ''}${elapsed.milliseconds}`;
        }, 10); // Update every 10ms for precision
    }

    // Method to create the game scene
    createScene() {
        // Initializing variables for track generation
        this.track = null;
        this.indicatorArrow = null;
        // Adding the initial track and sky to the scene
        this.addTrack();

        this.addCollectables();
    }

    // Method to process children of a given object
    processChilds(child) {
        child.children && child.children.forEach((child) => {
            // Setting material properties for visual consistency
            child.material.roughness = 1;
        });
    }
    findNearestPointOnCurve(position) {
        if (!Global.AIPath3) return false;
        // Number of divisions to use for approximation
        const divisions = 1000;

        let nearestPoint = null;
        let pathTime = -1;
        let minDistance = Infinity;

        // Iterate through divisions to find the nearest point
        for (let i = 0; i <= divisions; i++) {
            const t = i / divisions;
            const pointOnCurve = Global.AIPath3.getPoint(t);
            pointOnCurve.x = position.x;
            const distance = position.distanceTo(pointOnCurve);

            if (distance < minDistance) {
                minDistance = distance;
                nearestPoint = pointOnCurve;
                pathTime = t;
            }
        }

        return pathTime;
    }
    moveBlocker(data){
        if(this.blockerMesh){
            let closestPos = this.findNearestPointOnCurve(data.position.clone()/* .multiplyScalar(20) */);
            // this.speed = 0;
            // this.carRotateZ=0;
            // this.baseSpeedCrossed = false;
        
        
            this.aiPos = Global.AIPath3.getPoint(Math.max(0,closestPos-.001));
            this.aiPos2 = Global.AIPath3.getPoint(Math.max(0,closestPos-.0005));
        
            let nextPosX = THREE.MathUtils.lerp(data.position.x, this.aiPos.x, 1);
            let nextPosY = THREE.MathUtils.lerp(data.position.y, this.aiPos.y + 0.05, 1);
            let nextPosZ = THREE.MathUtils.lerp(data.position.z, this.aiPos.z, 1);
        
            let nextPos = new THREE.Vector3(nextPosX, nextPosY, nextPosZ);

            let direction = new THREE.Vector3().subVectors(this.aiPos2, data.position).normalize();
        
            // Calculate the angle around the Y-axis
            let angle = Math.atan2(direction.x, direction.z)+90;

            // this.blockerMesh.rotation.y = angle;
            // console.log(data.position,'/data.position')
            this.blockerMesh.position.copy(nextPos.multiplyScalar(1/20));
        }
        //5_cans
    }
    // Method to add a track to the scene based on a given index
    addTrack() {
        // Initializing arrays to store track elements
        this.roadsToTrack = [];
        this.wallsToTrack = [];

        this.scene.fog = new THREE.Fog(0xffffff, 100,1e3); // Adjust near & far values

        this.skybox= Global.assets['glbs'][Global.gameLevel==1?'skybox':'skybox2']['asset'].scene;
        this.scene.add(this.skybox);
        Global.skybox=this.skybox;
        this.skybox.position.y=-10;
        // this.skybox.scale.set(1.3,1.3,1.3)
        this.skybox.traverse((child) => {
            if(!child.material) return false;

            child.layers.set(100);
            child.material.depthWrite=false;
            // child.renderOrder=-1
            child.material.envMap=Global.envMap;
            // child.material.alphaTest=0;
            child.material.encoding= THREE.sRGBEncoding
            child.material.colorSpace= THREE.SRGBColorSpace
            child.material.envMapIntensity=4;
            // child.material.color=0xff0000;
            child.material.opacity=0.35;
          
        });
        
        this.speedControlerMat = new THREE.MeshPhysicalMaterial({
            // color: '#ff0000',
            side: THREE.DoubleSide,
            transparent: true,
            opacity: 0
        })

        // Cloning the road asset from global assets
        this.track = Global.assets['glbs'][`${Global.gameLevel==1?'beach':Global.gameLevel==2?'city':'mountain'}_road`]['asset'].scene.clone();
        this.track.scale.set(20,20,20)
        this.scene.add(this.track);
        
      
        // this.track.visible=false;

        if(Global.gameLevel==3){
            this.track2 = Global.assets['glbs']['mountain_road2']['asset'].scene.clone();
            this.track2.scale.set(20,20,20)
            this.scene.add(this.track2);

            this.track2.traverse((child) => {
                if (child.material ) {
                    child.material.depthWrite=true;
                    child.material.alphaTest =0.1;//0.0001
                    child.material.envMap=Global.envMap
                 
                 
                    child.material.map.magFilter = THREE.NearestFilter; // Prevents smoothing when scaling up
                    child.material.map.minFilter = THREE.NearestFilter; // Prevents mipmapping smoothing
                    child.material.map.generateMipmaps = false; // Disables automatic mipmaps
                    child.material.map.needsUpdate = true;
                 
                
                    if(child.material.name.toLowerCase().indexOf('water') !== -1){
                        child.material.envMapIntensity = 1.5;
                    }else{
                        child.material.envMapIntensity = 3.0;
                    }
                    if(child.name.indexOf('5_cans')!==-1){
                        this.blockerMesh=child;
                        this.wallsToTrack.push(child)
                        this.blockerMesh.material.side= THREE.DoubleSide
                       }
                }
            })
        }
   


        this.startingLine = Global.assets['glbs']['startingLine']['asset'].scene.clone();
        this.starlineTxt=new THREE.Mesh(
            new THREE.PlaneGeometry(10,2),
            new THREE.MeshBasicMaterial({
                map:Global.assets['textures']["check_line"]['asset'],
                opacity:1,
                transparent:true,
                depthWrite:false,
                // depthTest:false
            })
        )
        this.scene.add(this.startingLine);
        this.scene.add(this.starlineTxt);
        this.starlineTxt.rotation.set(START_LINE_ROT.x, START_LINE_ROT.y,START_LINE_ROT.z);//
        this.startingLine.position.set(START_LINE_POS.x, START_LINE_POS.y,START_LINE_POS.z);
        this.starlineTxt.position.set(START_LINE_POS.x+0.2, START_LINE_POS.y+1.41,START_LINE_POS.z-0.5);
        this.startingLine.scale.set(1.3,1.3,1.3)
        this.startingLine.rotation.y=-Math.PI*.013
        this.startingLine.traverse((item) => {
            if(item.material){
                item.material.envMap = Global.envMap;
                item.material.envMapIntensity = 2.0;
           
            }
        })


        this.finishLine = Global.assets['glbs'][`finishLine${Global.gameLevel==3?'2':''}`]['asset'].scene.clone();
        this.finishLineTxt = new THREE.Mesh(
            new THREE.PlaneGeometry(10,2),
            new THREE.MeshBasicMaterial({
                map:Global.assets['textures']["check_line"]['asset'],
                opacity:1,
                transparent:true,
                depthWrite:false,
                depthTest:false
            })
        )
        this.scene.add(this.finishLine);
       
        this.finishLine.traverse((item) => {
            if(item.material){
                item.material.envMap = Global.envMap;
                item.material.alphaTest=0.1;
                item.material.depthWrite=true;
                item.material.envMapIntensity = 4.0;
           
            }
        })

       
        
        if(Global.gameLevel==3){
            this.finishLine.scale.set(8,8,8)
            this.finishLine.position.set(FINISH_LINE_POS.x, FINISH_LINE_POS.y+1.4,FINISH_LINE_POS.z);
        }else{
            this.finishLine.scale.set(1.3,1.3,1.3)
            this.finishLine.position.set(FINISH_LINE_POS.x, FINISH_LINE_POS.y,FINISH_LINE_POS.z);
        }
      
        this.scene.add(this.finishLineTxt);

        
       
        this.finishLineTxt.position.set(FINISH_LINE_POS.x, FINISH_LINE_POS.y+1.2,FINISH_LINE_POS.z);
        this.finishLineTxt.rotation.set(FINISH_LINE_ROT.x,FINISH_LINE_ROT.y,FINISH_LINE_ROT.z);//Global.assets['glbs']['startingLine']['asset'].scene.clone();
    
        this.finishLineTxt2= new THREE.Mesh(
            new THREE.PlaneGeometry(10,2),
            new THREE.MeshBasicMaterial({
                map:Global.assets['textures']["check_line"]['asset'],
                opacity:0,
                transparent:true,
                depthWrite:false,
                depthTest:false
            })
        )
        this.finishLineTxt2.rotation.set(FINISH_LINE_ROT.x,FINISH_LINE_ROT.y,FINISH_LINE_ROT.z);
        this.finishLineTxt3= this.finishLineTxt2.clone();
        this.finishLineTxt4= this.finishLineTxt2.clone();

        this.scene.add(this.finishLineTxt2);
        this.scene.add(this.finishLineTxt3);
        this.scene.add(this.finishLineTxt4);

        this.finishLineTxt2.position.set(FINISH_LINE_POS.x, FINISH_LINE_POS.y+1.2,FINISH_LINE_POS.z-2);
        this.finishLineTxt3.position.set(FINISH_LINE_POS.x, FINISH_LINE_POS.y+1.2,FINISH_LINE_POS.z-4);
        this.finishLineTxt4.position.set(FINISH_LINE_POS.x, FINISH_LINE_POS.y+1.2,FINISH_LINE_POS.z-6);

        // this.finishLineTxt.visible=false;

        
        this.scene.add(this.finishLine);

        // this.events.dispatchEvent({
        //     type: "PLAYER_EVENTS",
        //     message: {
        //         "event_type": "move_player",
        //         "data": {
        //             "position": this.finishLine.position.clone(),
        //             "rotation": this.finishLine.rotation.clone(),
        //             "entity": this.finishLine,
        //             "speed":2
        //         }
        //     }
        // });

       
        // this.track.renderOrder=1
        this.track.traverse((child) => {
           
            if(child.isMesh && child.material.name.indexOf('track')!==-1){
                child.material.map.anisotropy=10;
            }
            if (child.material ) {
               
                child.material.depthWrite=true;
                child.material.alphaTest =(Global.gameLevel==2?0.4:0.4)
       

          
                child.material.map && (child.material.map.colorSpace= THREE.SRGBColorSpace, child.material.map.needsUpdate=true);
                child.material.map && (child.material.map.encoding = THREE.sRGBEncoding, child.material.map.needsUpdate=true)
                   if(child.material.name.indexOf('side_area')!==-1 || child.material.name.indexOf('water')!==-1){
                    child.material.lightMap= child.material.map
                    child.material.envMap=Global.envMap
                    child.material.alphaTest=0;
                    child.material.envMapIntensity = 1;
                    // child.material.transparent=false;
                    // child.renderOrder=1
                    // child.material.depthTest=false;
                    
                   }
                  if(child.name.indexOf("Plane7648")!=-1){
                    // child.visible=false;
                  }
                if(
                    child.material.name.toLowerCase().indexOf('side_area') ==-1 &&
                    child.material.name.toLowerCase().indexOf('track') ==-1 
                ){
                    child.material.envMap=Global.envMap
             
                    if(child.material.name.toLowerCase().indexOf('water') !== -1){
                        child.material.envMapIntensity = 1.5;
                    }else{
                        child.material.envMapIntensity = 3.0;
                    }
                    
                    if(child.material.name.toLowerCase().indexOf("tree")!==-1){
                    
                    }
                }/*   else{
                    child.material.envMap=Global.envMap
                    child.material.envMapIntensity = 1.5;
                } */
               if(child.name.indexOf('5_cans')!==-1){
                this.blockerMesh=child;
                this.wallsToTrack.push(child)
                this.blockerMesh.material.side= THREE.DoubleSide
               }
            }
            
        
            if (child.name.toLowerCase().indexOf("road") != -1 && child.name.toLowerCase().indexOf("side") === -1) {
                this.processChilds(child);
                this.roadsToTrack.push(child);
            }
            //
            if (child.name.indexOf("speed_limiter") != -1 || child.name.indexOf("speed_activator") != -1 || child.name.indexOf("indicator_trigger") != -1) {
                child.material = this.speedControlerMat;
                if (child.name.indexOf("speed_limiter") != -1) {

                    child.userData = {
                        'direction': child.name.split('__')[1]
                    }
                    Global.speedLimiters.push(child);
                } else if (child.name.indexOf("speed_activator") != -1) {
                    Global.speedActivators.push(child);
                } else if (child.name.indexOf("indicator_trigger") != -1) {
                    let direction = child.name.split('__')[1];
                    let index = parseInt((child.name.split('__')[0]).split('indicator_trigger')[1])
                    child.userData = {
                        'direction': child.name.split('__')[1],
                        'index': index
                    }
                    Global.speedIndicator.push(child);
                }

            }
            // speedLimiters
            
            if (
                child.name.toLowerCase().indexOf('wall') != -1 ||
                child.name.toLowerCase().indexOf('collider') != -1 ||
                child.name.toLowerCase().indexOf('colider') != -1
            ) {
                child.visible = false;
                this.wallsToTrack.push(child);
            }

        });

    }
    showOrHideIndicator(status, data) {
        this.indicator.scene.visible = status;
        if(this.track.getObjectByName(`speed_limiter${data['indicator_index']}__${data['rotation_direction']}`)){
            status && (this.indicator.scene.position.set(...this.track.getObjectByName(`speed_limiter${data['indicator_index']}__${data['rotation_direction']}`).position) /* ,  this.indicator.scene.rotation.y+=Math.PI */ );

            if (data['rotation_direction']) {
                status && (this.indicatorArrow.rotation.y = this.indicator.scene.rotation.y + Math.PI * (data['rotation_direction'] == 'left' ? -1 : 0));
            }
        }
       

    }
      
    // Update method for scene adjustments
    update(data) {
    
        this.events.dispatchEvent({
            type: "GAMESCENE_EVENTS",
            message: {
                "event_type": "align_car_to_elevation",
                data: {
                    'road': this.roadsToTrack,
                    'finishLine': [
                        this.finishLineTxt,
                        this.finishLineTxt2,
                        this.finishLineTxt3,
                        this.finishLineTxt4
                    ],
                    'wall': this.wallsToTrack,
                    'left_lane': this.leftLane,
                    'right_lane': this.rightLane
                }
            }
        });
        this.events.dispatchEvent({
            type: "GAMESCENE_EVENTS",
            message: {
                "event_type": "check_speed_control",
                data: {
                    'finishLine': [
                        this.finishLineTxt,
                        this.finishLineTxt2,
                        this.finishLineTxt3,
                        this.finishLineTxt4
                    ]
                }
            }
        });

        if(this.skybox){
            this.skybox.position.z=this.scene.camera.position.z+210/* +210 */;
            this.skybox.position.x=this.scene.camera.position.x;
            this.skybox.position.y=this.scene.camera.position.y-0.5;
        }
        
    }
    dispose() {
        // Dispose all collectables

        Global.collectables.forEach((collectable) => {
            this.scene.remove(collectable);
            
            if (collectable.geometry) {
                collectable.geometry.dispose();
            }
    
            if (collectable.material) {
                if (Array.isArray(collectable.material)) {
                    collectable.material.forEach(mat => {
                        if (mat.map) mat.map.dispose();
                        mat.dispose();
                    });
                } else {
                    if (collectable.material.map) collectable.material.map.dispose();
                    collectable.material.dispose();
                }
            }
        });
        // Clear the collectables array
        Global.collectables = [];
    
        
        // Dispose of track and other objects
        if (this.track) {
           
            if (this.track.geometry) this.track.geometry.dispose();
            if (this.track.material) this.track.material.dispose();
            this.scene.remove(this.track);
        }
    
        if (this.track2) {
            if (this.track2.geometry) this.track2.geometry.dispose();
            if (this.track2.material) this.track2.material.dispose();
            this.scene.remove(this.track2);
        }
    
        // Dispose of skybox
        if (this.skybox) {
            if (this.skybox.material) this.skybox.material.dispose();
            if (this.skybox.geometry) this.skybox.geometry.dispose();
            this.scene.remove(this.skybox);
        }
    
        // Remove static elements
        [this.startingLine, this.starlineTxt, this.finishLine, this.finishLineTxt].forEach((obj) => {
            if (obj) {
                this.scene.remove(obj);
            }
        });
        this.events.removeEventListener("GAMESCENE_EVENTS", this.onEvents);
        this.events.removeEventListener("PLAYER_EVENTS", this.onEvents);
        this.events.removeEventListener("GAME_EVENTS", this.onEvents);
        // Force garbage collection (for Chrome, mostly)
        if (window.gc) {
            window.gc();
        }
    }
    
}